export default {
  labels: {
    store: 'Store',
    deliveryLimit: 'Delivery Distance Limit',
    fixedCharges: 'Delivery Charge',
    variableCharges: 'Delivery Charge',
    deliveryType: 'Delivery Type',
    content: 'Content',
  },
  submitMessages: {
    delivery: 'Delivery Charges Updated Successfully.',
  },
  titles: {
    content: 'Contents List',
  },
  placeholders: {
    selectStore: 'Select Store',
    enterDeliveryLimit: 'Enter Distance Limit',
    enterFixedCharges: 'Enter the amount',
  },
};
